import { render, staticRenderFns } from "./RegisterInExam.vue?vue&type=template&id=2ccde089&"
import script from "./RegisterInExam.vue?vue&type=script&lang=js&"
export * from "./RegisterInExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports